namespace e5.ScrollViewWheel {
    class ScrollViewWheelScroll implements IScrollViewWheel {
        public apply(view: ScrollView, deltaY:number, event: WheelEvent): void {

            var t = view.getTransformTarget();
            // view.y -= deltaY * 30;
            t.y -= deltaY * 100;
            view.setTransformClamped(t, 0.3);
        }
    }
    export const Scroll = new ScrollViewWheelScroll();
}